__turbopack_context__.v({
  "reactivateBtn": "ReactivateLoadLorry-module-scss-module__d6zeaW__reactivateBtn",
  "reactivateBtnWrapper": "ReactivateLoadLorry-module-scss-module__d6zeaW__reactivateBtnWrapper",
});
